import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 1.01L5.01 1v22H19V1.01zM17 19H7V5h10v14z"
}), 'StayCurrentPortraitSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/StayCurrentPortraitSharp.js
// module id = 6491
// module chunks = 2